module.exports = __webpack_public_path__ + "static/media/Eco_Grand_Hydrotech.bea3b455.jpg";